export const model = {
  newModel: "New Model",
  editModel: "Edit Model",
  pleaseInputModelName: "Please input a model name",
  pleaseInputMake: "Please input the vehicle make",
  pleaseSelectDriveTrainType: "Please select a drive train type",
  modelDetails: "Model Details",
  vehicleModelDeletion: "Vehicle Model Deletion",
  // Format: type ["detail1", "detail2", ......]
  deleteInformation: `To delete the vehicle model "{0}" you must apply a new vehicle model or delete the vehicle(s) from the list below. (If a vehicle is deleted the system will be unregistered and stop sending data.)`,
  vehicleList: "Vehicle List",
  selectVehicleModel: "Select a vehicle model",
  deleteVehicle: "Delete Vehicle",
  // Format: type ["detail1", "detail2", ......]
  deleteNoUsedTip:
    'The vehicle model "{0}" will be deleted. Are you sure you want to proceed?',
  // Format: type ["detail1", "detail2", ......]
  deleteUsedTip:
    'Confirm to delete the vehicle model "{0}" and apply the changes?',
  failedToSaveModelNameAlreadyExist:
    "Failed to save. The model name already exists.",
};
